import { AddProductBodyProductSource } from '~/src/queries/api-ecom/generated/api-ecom.schemas';
import { AdditionalAnalyticsData } from '~/src/screens/CatalogContent/ContentScreen/types';

// Extraction de la props 'from' des sources
type RecipeSource = Extract<
  AddProductBodyProductSource,
  { type: 'essentials recipe ingredients list' | 'recipe ingredients list' }
>;
type SimpleRecipeSource = Omit<RecipeSource, 'detail'> & {
  detail: Omit<MainProductSource['detail'], 'from'>;
};

type MainProductSource = Extract<AddProductBodyProductSource, { type: 'main product' }>;
type SimpleMainProductSource = Omit<MainProductSource, 'detail'> & {
  detail: Omit<MainProductSource['detail'], 'from'>;
};

// Sources possibles pour les fiches produits et recettes
type ProductLinkSource =
  | Exclude<
      AddProductBodyProductSource,
      { type: 'essentials recipe ingredients list' | 'recipe ingredients list' | 'main product' }
    >
  | SimpleRecipeSource
  | SimpleMainProductSource
  | { type: 'product informations changes list' | 'ingredient substitute list' };

export type RecipeLinkSource =
  | Extract<
      AddProductBodyProductSource,
      {
        type: 'products list' | 'search results';
      }
    >
  | { type: 'cart' };

type ProductLinkData = { source: ProductLinkSource } & AdditionalAnalyticsData;

type RecipeLinkData = { source: RecipeLinkSource } & AdditionalAnalyticsData;

/**
 * It returns generated catalog content link page
 * @param slug String for the slug property of a catalog content
 * @param path String for the path of a catalog content
 * @param options Object with category, subcategory and eventSource properties (optionnals)
 */
const useCatalogContentLink = (
  slug: string,
  contentData:
    | { path: 'produit'; data: ProductLinkData }
    | { path: 'recette'; data: RecipeLinkData },
) => {
  return {
    as: `/${contentData.path}/${slug}`,
    query: {
      type: contentData.data.source.type,
      ...('detail' in contentData.data.source ? contentData.data.source.detail : {}),
      slug,
    },
  };
};

export const useProductLink = (slug: string, data: ProductLinkData) =>
  useCatalogContentLink(slug, { path: 'produit', data });

export const useRecipeLink = (slug: string, data: RecipeLinkData) =>
  useCatalogContentLink(slug, { path: 'recette', data });
